/* eslint-disable */
/**
 * Generated `api` utility.
 *
 * THIS CODE IS AUTOMATICALLY GENERATED.
 *
 * To regenerate, run `npx convex dev`.
 * @module
 */

import type * as accessGrants from "../accessGrants.js";
import type * as admins from "../admins.js";
import type * as ai from "../ai.js";
import type * as anchorReviews from "../anchorReviews.js";
import type * as anchorSnapshots from "../anchorSnapshots.js";
import type * as anchors from "../anchors.js";
import type * as bookmarks from "../bookmarks.js";
import type * as chapterTitle from "../chapterTitle.js";
import type * as checkout from "../checkout.js";
import type * as classroom from "../classroom.js";
import type * as conversionUpload from "../conversionUpload.js";
import type * as conversions from "../conversions.js";
import type * as crons from "../crons.js";
import type * as deploy from "../deploy.js";
import type * as engagement from "../engagement.js";
import type * as glossStats from "../glossStats.js";
import type * as lib_access from "../lib/access.js";
import type * as lib_boundedFetch from "../lib/boundedFetch.js";
import type * as lib_checkoutClient from "../lib/checkoutClient.js";
import type * as lib_clock from "../lib/clock.js";
import type * as lib_entitlements from "../lib/entitlements.js";
import type * as lib_googleAccessToken from "../lib/googleAccessToken.js";
import type * as lib_logEvent from "../lib/logEvent.js";
import type * as lib_pricing from "../lib/pricing.js";
import type * as lib_subscriptions from "../lib/subscriptions.js";
import type * as matter from "../matter.js";
import type * as matterPendingEdits from "../matterPendingEdits.js";
import type * as model_accessGrant from "../model/accessGrant.js";
import type * as model_adminRole from "../model/adminRole.js";
import type * as model_anchor from "../model/anchor.js";
import type * as model_anchorInvariants from "../model/anchorInvariants.js";
import type * as model_anchorReview from "../model/anchorReview.js";
import type * as model_anchorSnapshot from "../model/anchorSnapshot.js";
import type * as model_anchoredExport from "../model/anchoredExport.js";
import type * as model_applyEdits from "../model/applyEdits.js";
import type * as model_attribution from "../model/attribution.js";
import type * as model_block from "../model/block.js";
import type * as model_blockEdit from "../model/blockEdit.js";
import type * as model_blockId from "../model/blockId.js";
import type * as model_blockMarkdown from "../model/blockMarkdown.js";
import type * as model_bookConfig from "../model/bookConfig.js";
import type * as model_bookmark from "../model/bookmark.js";
import type * as model_bookmarkMerge from "../model/bookmarkMerge.js";
import type * as model_checkoutOrder from "../model/checkoutOrder.js";
import type * as model_classroomInquiry from "../model/classroomInquiry.js";
import type * as model_conversionUpload from "../model/conversionUpload.js";
import type * as model_dataManagerEvent from "../model/dataManagerEvent.js";
import type * as model_describe from "../model/describe.js";
import type * as model_engagementTier from "../model/engagementTier.js";
import type * as model_engagementUpload from "../model/engagementUpload.js";
import type * as model_entitlement from "../model/entitlement.js";
import type * as model_gloss from "../model/gloss.js";
import type * as model_glossInput from "../model/glossInput.js";
import type * as model_googleServiceAccount from "../model/googleServiceAccount.js";
import type * as model_language from "../model/language.js";
import type * as model_location from "../model/location.js";
import type * as model_logEvent from "../model/logEvent.js";
import type * as model_matterMarkdown from "../model/matterMarkdown.js";
import type * as model_matterPendingEdit from "../model/matterPendingEdit.js";
import type * as model_pendingEdit from "../model/pendingEdit.js";
import type * as model_planCatalog from "../model/planCatalog.js";
import type * as model_premiumAccess from "../model/premiumAccess.js";
import type * as model_pricing from "../model/pricing.js";
import type * as model_productCatalog from "../model/productCatalog.js";
import type * as model_publishPlan from "../model/publishPlan.js";
import type * as model_readMark from "../model/readMark.js";
import type * as model_readingCohort from "../model/readingCohort.js";
import type * as model_readingProgress from "../model/readingProgress.js";
import type * as model_readingStats from "../model/readingStats.js";
import type * as model_receipt from "../model/receipt.js";
import type * as model_receiptVerify from "../model/receiptVerify.js";
import type * as model_renumberBlocks from "../model/renumberBlocks.js";
import type * as model_retellingMarkdown from "../model/retellingMarkdown.js";
import type * as model_returnOrigin from "../model/returnOrigin.js";
import type * as model_selection from "../model/selection.js";
import type * as model_session from "../model/session.js";
import type * as model_shelfOrder from "../model/shelfOrder.js";
import type * as model_subscriptionAccess from "../model/subscriptionAccess.js";
import type * as model_subscriptionConversionValue from "../model/subscriptionConversionValue.js";
import type * as model_subscriptionReceipt from "../model/subscriptionReceipt.js";
import type * as model_tokenUsage from "../model/tokenUsage.js";
import type * as model_translationQuota from "../model/translationQuota.js";
import type * as model_unitOrder from "../model/unitOrder.js";
import type * as model_volume from "../model/volume.js";
import type * as model_wordGloss from "../model/wordGloss.js";
import type * as pendingEdits from "../pendingEdits.js";
import type * as premium from "../premium.js";
import type * as pricing from "../pricing.js";
import type * as publish from "../publish.js";
import type * as readMarks from "../readMarks.js";
import type * as reading from "../reading.js";
import type * as retell from "../retell.js";
import type * as seed from "../seed.js";
import type * as shelf from "../shelf.js";
import type * as stats from "../stats.js";
import type * as subscriptions from "../subscriptions.js";

import type {
  ApiFromModules,
  FilterApi,
  FunctionReference,
} from "convex/server";
import { anyApi, componentsGeneric } from "convex/server";

const fullApi: ApiFromModules<{
  accessGrants: typeof accessGrants;
  admins: typeof admins;
  ai: typeof ai;
  anchorReviews: typeof anchorReviews;
  anchorSnapshots: typeof anchorSnapshots;
  anchors: typeof anchors;
  bookmarks: typeof bookmarks;
  chapterTitle: typeof chapterTitle;
  checkout: typeof checkout;
  classroom: typeof classroom;
  conversionUpload: typeof conversionUpload;
  conversions: typeof conversions;
  crons: typeof crons;
  deploy: typeof deploy;
  engagement: typeof engagement;
  glossStats: typeof glossStats;
  lib_access: typeof lib_access;
  lib_boundedFetch: typeof lib_boundedFetch;
  lib_checkoutClient: typeof lib_checkoutClient;
  lib_clock: typeof lib_clock;
  lib_entitlements: typeof lib_entitlements;
  lib_googleAccessToken: typeof lib_googleAccessToken;
  lib_logEvent: typeof lib_logEvent;
  lib_pricing: typeof lib_pricing;
  lib_subscriptions: typeof lib_subscriptions;
  matter: typeof matter;
  matterPendingEdits: typeof matterPendingEdits;
  model_accessGrant: typeof model_accessGrant;
  model_adminRole: typeof model_adminRole;
  model_anchor: typeof model_anchor;
  model_anchorInvariants: typeof model_anchorInvariants;
  model_anchorReview: typeof model_anchorReview;
  model_anchorSnapshot: typeof model_anchorSnapshot;
  model_anchoredExport: typeof model_anchoredExport;
  model_applyEdits: typeof model_applyEdits;
  model_attribution: typeof model_attribution;
  model_block: typeof model_block;
  model_blockEdit: typeof model_blockEdit;
  model_blockId: typeof model_blockId;
  model_blockMarkdown: typeof model_blockMarkdown;
  model_bookConfig: typeof model_bookConfig;
  model_bookmark: typeof model_bookmark;
  model_bookmarkMerge: typeof model_bookmarkMerge;
  model_checkoutOrder: typeof model_checkoutOrder;
  model_classroomInquiry: typeof model_classroomInquiry;
  model_conversionUpload: typeof model_conversionUpload;
  model_dataManagerEvent: typeof model_dataManagerEvent;
  model_describe: typeof model_describe;
  model_engagementTier: typeof model_engagementTier;
  model_engagementUpload: typeof model_engagementUpload;
  model_entitlement: typeof model_entitlement;
  model_gloss: typeof model_gloss;
  model_glossInput: typeof model_glossInput;
  model_googleServiceAccount: typeof model_googleServiceAccount;
  model_language: typeof model_language;
  model_location: typeof model_location;
  model_logEvent: typeof model_logEvent;
  model_matterMarkdown: typeof model_matterMarkdown;
  model_matterPendingEdit: typeof model_matterPendingEdit;
  model_pendingEdit: typeof model_pendingEdit;
  model_planCatalog: typeof model_planCatalog;
  model_premiumAccess: typeof model_premiumAccess;
  model_pricing: typeof model_pricing;
  model_productCatalog: typeof model_productCatalog;
  model_publishPlan: typeof model_publishPlan;
  model_readMark: typeof model_readMark;
  model_readingCohort: typeof model_readingCohort;
  model_readingProgress: typeof model_readingProgress;
  model_readingStats: typeof model_readingStats;
  model_receipt: typeof model_receipt;
  model_receiptVerify: typeof model_receiptVerify;
  model_renumberBlocks: typeof model_renumberBlocks;
  model_retellingMarkdown: typeof model_retellingMarkdown;
  model_returnOrigin: typeof model_returnOrigin;
  model_selection: typeof model_selection;
  model_session: typeof model_session;
  model_shelfOrder: typeof model_shelfOrder;
  model_subscriptionAccess: typeof model_subscriptionAccess;
  model_subscriptionConversionValue: typeof model_subscriptionConversionValue;
  model_subscriptionReceipt: typeof model_subscriptionReceipt;
  model_tokenUsage: typeof model_tokenUsage;
  model_translationQuota: typeof model_translationQuota;
  model_unitOrder: typeof model_unitOrder;
  model_volume: typeof model_volume;
  model_wordGloss: typeof model_wordGloss;
  pendingEdits: typeof pendingEdits;
  premium: typeof premium;
  pricing: typeof pricing;
  publish: typeof publish;
  readMarks: typeof readMarks;
  reading: typeof reading;
  retell: typeof retell;
  seed: typeof seed;
  shelf: typeof shelf;
  stats: typeof stats;
  subscriptions: typeof subscriptions;
}> = anyApi as any;

/**
 * A utility for referencing Convex functions in your app's public API.
 *
 * Usage:
 * ```js
 * const myFunctionReference = api.myModule.myFunction;
 * ```
 */
export const api: FilterApi<
  typeof fullApi,
  FunctionReference<any, "public">
> = anyApi as any;

/**
 * A utility for referencing Convex functions in your app's internal API.
 *
 * Usage:
 * ```js
 * const myFunctionReference = internal.myModule.myFunction;
 * ```
 */
export const internal: FilterApi<
  typeof fullApi,
  FunctionReference<any, "internal">
> = anyApi as any;

export const components = componentsGeneric() as unknown as {};
